import { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-home.jpeg";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { Search } from "../../hooks/useGeneralSearch";
import { Container } from "../../theme/styles";
import { Form } from "./components/Form";
import { Results } from "./components/Results";
import { Modal } from "../../components/Modal";
import mock from "../../mocks/info";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";

function GeneralResults() {
  usePageTrack();

  const [results, setResult] = useState<any[]|null>(null);

  const [clickedInfo, setClickedInfo] = useState(mock);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const location: any = useLocation();
  
  const firstResults: string[] = [
    ...location?.state?.data?.decisions?.results, 
    ...location?.state?.data?.normas?.results, 
    ...location?.state?.data?.dissertations?.results,
    ...location?.state?.data?.publications?.results,
  ];
  const initialSearch: Search = location?.state?.search;

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Content>
        <Form 
          setResult={setResult}
          initialSearch={initialSearch}
        />
        <Results 
          results={results || firstResults}
          onClick={(clicked) => {
            setClickedInfo(clicked);
            setIsModalOpen(true);
          }}
        />
        <Modal isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {clickedInfo.map(info => (
          <div key={info.title} ref={info.content}>
              <span>{info.title}</span>
              <section>{info.content}</section>
            </div>
          ))}
        </Modal>
      </Content>
      <Footer />
    </>
  );
}

export default GeneralResults;

const Content = styled(Container)`
  padding: 32px 0 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
  }
`;